<div class="main-content">
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
